import React, { Component } from "react";
import TabBorderItem from "./items/border";
import AfshanTabBackgroundItem from "./items/afshanBackground";

export default class AfshanTabItems extends Component {
  render() {
    const { stepOnboarding } = this.props;
    return (
      <ul
        className="ul-background-select"
        style={{ zIndex: stepOnboarding === 3 ? 1 : 0 }}
      >
        <TabBorderItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
        <AfshanTabBackgroundItem
          texts={this.props.texts}
          activePartsTab={this.props.activePartsTab}
          partsTabHandler={this.props.partsTabHandler}
          themeDirection={this.props.themeDirection}
        />
      </ul>
    );
  }
}
